import { Link } from 'apps/shared/scripts/components';

import {
  footerLabelClassName,
  footerLinkClassName,
  footerLinkWrapperClassName,
  summaryFooterClassName,
} from './styles';

const SummaryFooter = () => {
  return (
    <div className={summaryFooterClassName}>
      <span className={footerLabelClassName}>
        For more details and all features
      </span>
      <div className={footerLinkWrapperClassName}>
        <Link className={footerLinkClassName} to="/">
          View pricing page
        </Link>
      </div>
    </div>
  );
};

SummaryFooter.displayName = 'SummaryFooter';

export default SummaryFooter;
